import square from '../img/square.png';

export const Background = () => (
  <div
    className="absolute inset-x-0 top-0 z-0 size-full"
    style={{
      height: '1397px',
      background: `
        linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 100%), 
        url(${square}) center/cover no-repeat
      `,
    }}
  ></div>
);
